import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Link } from "react-router-dom";
import { RiUploadCloudLine } from "react-icons/ri";
import styles from "../BookRollUpload.module.css";

class CustomDropZone extends React.Component {
  render() {
    let {
      fileList,
      updateFileList,
      removeFile,
      heading,
      uploadMsg,
      downloadFileName,
    } = this.props;
    let listToShow = [];

    for (let fileName in fileList) {
      listToShow.push(
        <li
          className="list-group-item d-flex justify-content-between"
          key={fileName}
        >
          <span>{fileName}</span>
          {fileList[fileName] !== "#empty" && uploadMsg !== "files uploaded" && (
            <span className="fw-bold" onClick={() => removeFile(fileName)}>
              {"X"}
            </span>
          )}
        </li>
      );
    }

    return (
      <div className={styles.customDropZone}>
        <div className="d-flex justify-content-between align-items-center">
          <h4>{heading}</h4>
          <Link
            to={{ pathname: downloadFileName }}
            target="_blank"
            className="d-flex align-items-center"
            download
          >
            <h6 className="download-icon">Download reference file</h6>
            {/* <div style={{ fontWeight: "900", fontSize: "24px" }}>⬇</div> */}
          </Link>
        </div>
        <DropZone updateFileList={updateFileList} />
        {<ul className="list-group list-group-flush">{listToShow}</ul>}
      </div>
    );
  }
}

const DropZone = (props) => {
  let { updateFileList } = props;
  const [errorMsg, setErrorMsg] = useState("");

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    setErrorMsg("");

    if (fileRejections.length > 0) {
      setErrorMsg("Please select a CSV File.");
      return;
    }

    acceptedFiles.forEach((file) => {
      updateFileList(file);
    });
  }, []);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: ".csv",
    multiple: false,
  });

  return (
    <>
      <div {...getRootProps({ className: styles.dropzone })}>
        <input {...getInputProps()} />
        <RiUploadCloudLine className="cloud-icon" />
        <div className="dropZoneText">Drag &amp; Drop or Browse File</div>
      </div>

      {errorMsg && (
        <p style={{ color: "red", marginTop: "0.5rem" }}>{errorMsg}</p>
      )}
    </>
  );
};

export default CustomDropZone;
